import { ReactElement } from 'react';
import * as React from 'react';

import styles from './login-modal.module.scss';
import { useTranslation } from 'next-i18next';
import { Popin } from '@utmb/design-system/popin/Popin';

import { Font } from '@utmb/design-system/text/font';
import { ButtonRemake } from '@utmb/design-system/button-remake/ButtonRemake';
import { useUser } from '@utmb/contexts/AuthContext';

interface LoginModalProps {
    isOpen: boolean;
    close: () => void;
}

export const LoginModal = ({ isOpen, close }: LoginModalProps): ReactElement | null => {
    const { t } = useTranslation();
    const { login, register } = useUser();

    return isOpen ? (
        <Popin closeCallback={() => close()}>
            <div className={styles.loginModal}>
                <Font.FuturaBold className={styles.title} desktop="18" mobile="18">
                    {t('common.signInPopin.title')}
                </Font.FuturaBold>
                <Font.FuturaBook className={styles.description} desktop="16" mobile="16">
                    {t('common.signInPopin.description')}
                </Font.FuturaBook>

                <div className={styles.wrapButtons}>
                    <ButtonRemake
                        customClassName={styles.buttonLogin}
                        variant="solid"
                        label={t('common.signIn')}
                        action={() => {
                            login();
                        }}
                    />
                    <ButtonRemake
                        customClassName={styles.buttonRegister}
                        variant="solid"
                        label={t('common.register')}
                        action={() => {
                            register();
                        }}
                    />
                </div>
            </div>
        </Popin>
    ) : null;
};
